module.exports = __webpack_public_path__ + "img/h51icon5.a229dafd.png";